import React from 'react';
import "./style.scss";
import TableWithDraggableRows, {Row} from "../TableWithDraggableRows/TableWithDraggableRows";
import AddressCell from "./Cells/AddressCell/AddressCell";
import ArrivalTimeCell from "./Cells/ArrivalTimeCell/ArrivalTimeCell";
import ArrivalTimeFromOrderTimeCell from "./Cells/ArrivalTimeFromOrderTimeCell/ArrivalTimeFromOrderTimeCell";

function RouteRow({index, route, row, isDragging, provided, snapshot, isEdit, onRemoveStopClicked}) {
    return (
        <Row
            ref={provided.innerRef}
            isDragging={snapshot.isDragging}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={"route-row" + (row.order.status === "DELIVERED" ? " route-row-delivered" : "")}
        >
            <AddressCell index={index}
                         route={route}
                         row={row}
                         isDragging={isDragging}
                         provided={provided}
                         snapshot={snapshot}
                         isEdit={isEdit}
                         onRemoveStopClicked={onRemoveStopClicked}/>
            <ArrivalTimeCell index={index}
                             route={route}
                             row={row}
                             isDragging={isDragging}
                             provided={provided}
                             snapshot={snapshot}/>
            <ArrivalTimeFromOrderTimeCell index={index}
                                          route={route}
                                          row={row}
                                          isDragging={isDragging}
                                          provided={provided}
                                          snapshot={snapshot}/>
        </Row>
    );
}

export default function SentRouteStopsTable({route, isEdit, onReorder, onRemoveStopClicked}) {
    return (
        <div className="route">
            <TableWithDraggableRows
                isDragEnabled={isEdit}
                className="route-table"
                columns={[
                    {title: "כתובת"},
                    {title: "זמן הגעה"},
                    {title: "זמן הגעה מקבלת ההזמנה"}
                ]}
                rowRenderer={(index, row, isDragging, provided, snapshot) => (
                    <RouteRow index={index}
                              route={route}
                              row={row}
                              isDragging={isDragging}
                              provided={provided}
                              snapshot={snapshot}
                              isEdit={isEdit}
                              onRemoveStopClicked={() => onRemoveStopClicked(row.order_id)}/>
                )}
                rowIdGetter={(row) => row.order_id}
                rows={route.route}
                onReorder={onReorder}
            />
        </div>
    );
}